// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3ii5V","choiceBoxes":"toolbarselects_choiceBoxes__RGGr4","simpleField":"toolbarselects_simpleField__28QbT"};